"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusSynchronizedStoreInformant = void 0;
const core_1 = require("../../core");
const types_1 = require("./types");
const utils_1 = require("./utils");
class EventBusSynchronizedStoreInformant {
    constructor(storeName, store, eventBus) {
        this.eventBus = eventBus;
        this.storeName = storeName;
        this.store = store;
        this.eventBus.subscribe((0, utils_1.getEventName)(this.storeName, types_1.BaseTypeMap.SET), (event) => {
            core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.storeName}: Event SET received: ${JSON.stringify(event)}`);
            const data = event.getData();
            if (data) {
                this.store.setItem(data.key, data.value);
            }
        });
        this.eventBus.subscribe((0, utils_1.getEventName)(this.storeName, types_1.BaseTypeMap.REMOVE), (event) => {
            core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.storeName}: Event REMOVE received: ${JSON.stringify(event)}`);
            const data = event.getData();
            if (data) {
                this.store.removeItem(data.key);
            }
        });
        this.eventBus.subscribe((0, utils_1.getEventName)(this.storeName, types_1.BaseTypeMap.CLEAR), (event) => {
            core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.storeName}: Event CLEAR received: ${JSON.stringify(event)}`);
            const data = event.getData();
            this.store.clear();
        });
    }
    removeItem(key) {
        this.eventBus.publish((0, utils_1.getEventName)(this.storeName, types_1.BaseTypeMap.REMOVE), new types_1.RemoveItemEvent({ key }));
        core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.storeName}: Event REMOVE published: ${key}`);
    }
    setItem(key, value) {
        this.eventBus.publish((0, utils_1.getEventName)(this.storeName, types_1.BaseTypeMap.SET), new types_1.SetItemEvent({ key, value }));
        core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.storeName}: Event SET published: ${key}:${value}`);
    }
    clear() {
        this.eventBus.publish((0, utils_1.getEventName)(this.storeName, types_1.BaseTypeMap.CLEAR), new types_1.ClearStoreEvent());
        core_1.Log.info(`[EventBusSynchronizedStoreInformant] ${this.storeName}: Event CLEAR published`);
    }
    getItem() {
        throw Error('[EventBusSynchronizedStoreInformant] Can not call getItem');
    }
}
exports.EventBusSynchronizedStoreInformant = EventBusSynchronizedStoreInformant;
//# sourceMappingURL=eventBusSynchronizedStoreInformant.js.map